// AUTO-GENERATED from `firebase apps:sdkconfig` for project dewviko-school-test.
// This file is gitignored. The committed template is firebase.config.example.ts.
// To regenerate: pnpm exec firebase apps:sdkconfig WEB <appId> --project dewviko-school-test

export const firebaseConfig = {
  apiKey: "AIzaSyCWltuD3ZgIxPN6wbT4d_vJZ9GW978GQU4",
  authDomain: "dewviko-school-test.firebaseapp.com",
  projectId: "dewviko-school-test",
  storageBucket: "dewviko-school-test.firebasestorage.app",
  messagingSenderId: "640634932895",
  appId: "1:640634932895:web:1928ccea2dce4e38a45caa",
};

export const region = "asia-southeast1";

export const adminUids: string[] = ["72uK52SjoEecIYbK901MZNEgaJi1", "phfxNNTg5rM4tUxPhMFW9BhheVM2"];
